import api from './api';

interface Function {
  id: number;
  industry: number;
  name: string;
  created_at: string;
  updated_at: string;
}

interface CreateFunctionData {
  industry: number;
  name: string;
}

export const listFunctions = async (industryId: number): Promise<Function[]> => {
  const response = await api.get(`functions/?industry=${industryId}`);
  return response.data;
};

export const createFunction = async (data: CreateFunctionData): Promise<Function> => {
  const response = await api.post(`functions/`, data);
  return response.data;
};

export const updateFunction = async (id: number, data: Partial<CreateFunctionData>): Promise<Function> => {
  const response = await api.patch(`functions/${id}/`, data);
  return response.data;
};

export const deleteFunction = async (id: number): Promise<void> => {
  await api.delete(`functions/${id}/`);
};